export type RunTabKey = 'needs-action' | 'running' | 'completed'

export const RUN_TABS: { key: RunTabKey; label: string; status: string; emptyMessage: string }[] = [
  { key: 'needs-action', label: 'Needs action', status: 'paused', emptyMessage: 'No runs waiting for input' },
  { key: 'running', label: 'Running', status: 'running,scheduled', emptyMessage: 'No running workflows' },
  { key: 'completed', label: 'Completed', status: 'succeeded,failed,stopped,partial-succeeded', emptyMessage: 'No completed runs yet' },
]
